export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12211.8adfa784.jpg";